// GENERATED FILE. Do not edit by hand. Produced by `bun run codegen`.

import Ajv from "ajv";
import addFormats from "ajv-formats";
import call from "../../sdk-helpers/call";
import { logError } from "../../sdk-helpers/shouldLog";

export type typePoolArchiveMineBody = {
  targetPoolId: string;
  isArchived: boolean;
};

export type typePoolArchiveMineOutput200 = {
  error?: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data?: null | { poolId: string; isArchived: boolean };
};

export type typePoolArchiveMineOutput400 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export type typePoolArchiveMineOutput401 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export type typePoolArchiveMineOutput500 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export const schemaPoolArchiveMineBody = {
  type: "object",
  properties: {
    targetPoolId: { type: "string", maxLength: 3000, minLength: 1 },
    isArchived: { type: "boolean" },
  },
  required: ["targetPoolId", "isArchived"],
} as const;

export type SdkOptions = {
  headers?: Record<string, string>;
  apiHost?: string;
  prefix?: string;
};

let compiledValidator: ReturnType<Ajv["compile"]> | null = null;

export default function createPoolArchiveMine(options: SdkOptions) {
  if (!compiledValidator) {
    const ajv = new Ajv({ strict: false });
    addFormats(ajv);
    compiledValidator = ajv.compile(schemaPoolArchiveMineBody);
  }

  return async function postPoolArchiveMine(
    payload: typePoolArchiveMineBody,
  ): Promise<typePoolArchiveMineOutput200 | typePoolArchiveMineOutput400> {
    const isValid = compiledValidator!(payload);
    if (!isValid) {
      logError(
        `Payload validation inside SDK method "postPoolArchiveMine" failed before calling the network. #827e8492a22b`,
        compiledValidator!.errors,
      );
      return {
        error: {
          code: "VALIDATION_ERROR",
          message: "Request payload failed schema validation.",
          details: { errors: compiledValidator!.errors, ref: "#827e8492a22b" },
        },
        data: null,
      } as typePoolArchiveMineOutput400;
    }

    const prefix = options?.prefix ?? "";
    return (await call({
      payload,
      endpoint: `${prefix}/pool/archive-mine`,
      httpMethod: "POST",
      options,
    })) as typePoolArchiveMineOutput200 | typePoolArchiveMineOutput400;
  };
}
